<template>
  <div
    class="bg-top bg-no-repeat w-full h-full bg-contain bg-black flex items-center justify-center"
  >
    <video
      id="myVideo"
      class="video-js vjs-default-skin vjs-big-play-centered"
      v-if="videoName !== null"
    >
      <source :src="videoUrl" type="video/mp4" />
      <!-- <source
        :src="`${publicPath}videos/mda-nbsd4qpasf0i6zps.mp4`"
        type="video/mp4"
      /> -->
      <!-- <source :src="'http://sulzer-industry.app.qianjiazi.com/#/videos/' + videoName + '.mp4'" type="video/mp4" /> -->
    </video>
  </div>
</template>
<script>
import Video from "video.js";
import "video.js/dist/video-js.css";
export default {
  name: "hello",
  data() {
    return {
      videoName: null,
      player: null,
      publicPath: process.env.BASE_URL,
      videoUrl: "",
    };
  },
  created() {
    this.videoUrl = this.$route.query.videoUrl;
    this.videoName = this.$route.params.name;
  },

  mounted() {
    setTimeout(() => {
      this.player = Video("myVideo", {
        controls: true,
        autoplay: true,
        poster: "",
        preload: "auto",
        width: "auto",
        height: "211px",
      });
      // this.player.play();
    }, 1000);
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>
<style scoped></style>
